<template>
    <div class="mag-teasers-articles" :class="background ? 'background' : ''">
        <sep name="XL" />
        <main-container class="mag-teaser-flash-articles">
            <sep name="XL" v-if="background" />
            <template v-if="!noTitle">
                <h2>
                    <typo name="title-30-normal">
                        {{ category.title }}
                    </typo>
                </h2>
                <typo name="body-16-normal">
                    {{ category.description }}
                </typo>
                <sep name="M" />
            </template>
            <div :style="styles">
                <div v-if="showArticles">
                    <div class="articles">
                        <mag-teaser-article
                            v-for="(article, index) in articlesSliced"
                            :key="article._ui"
                            :article="article"
                            :index="index"
                            :mode="category.mode"
                        />
                    </div>
                    <sep name="L" />
                    <div class="actions" v-if="this.articles.length > teaserNumber">
                        <action v-if="!showAll" name="light-border" @click="showAll = true">
                            Voir plus
                        </action>
                        <action v-if="showAll" name="light-border" @click="showAll = false">
                            Voir moins
                        </action>
                    </div>
                    <sep name="XL" />
                </div>
            </div>
        </main-container>
    </div>
</template>

<script>
import MagTeaserArticle from "./MagTeaserArticle.vue";
import { slice } from "lodash";

export default {
    props: {
        category: { type: Object, required: true },
        articles: { type: Array, required: true, default: () => [] },
        background: { type: Number },
        noTitle: { type: Boolean, default: false },
    },
    components: { MagTeaserArticle },
    data() {
        return {
            showAll: false,
            showArticles: false,
        };
    },
    computed: {
        teaserNumber() {
            const teaserNumberMap = {
                flash: 3,
                full: 3,
                half: 4,
            };
            return teaserNumberMap[this.category.mode] || 3;
        },
        styles() {
            const height = {
                flash: 350,
                full: 196 * Math.min(3, this.articles.length),
                half: 528,
            };
            return { minHeight: `${height[this.category.mode]}px` };
        },
        articlesSliced() {
            return this.showAll ? this.articles : slice(this.articles, 0, this.teaserNumber);
        },
    },
    mounted() {
        this.$nextTick(this.observe.bind(this));
    },
    methods: {
        observe() {
            this.observer = new IntersectionObserver(
                entries => {
                    this.observeTeaser(entries[0]);
                },
                { threshold: 0.25 }
            );
            this.observer.observe(this.$el);
        },
        observeTeaser(teaser) {
            if (teaser.isIntersecting) {
                this.showArticles = true;
                this.observer.unobserve(teaser.target);
            }
        },
    },
};
</script>

<style lang="sass" scoped>
.background
    background: $color-background

.articles
    display: flex
    align-content: stretch
    flex-wrap: wrap
    margin: 0 -$grid-gutter/2

.actions
    display: flex
    justify-content: center

@media print
    .mag-teasers-articles
        display: none
</style>
